import QueryTags from '../../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { OverdraftDrawdownEvaluateRequest, OverdraftLimitChangeRequest, OverdraftOptInRequest, OverdraftOptOutRequest } from './types/request'
import { CustomerDrawdowns, CustomerOverdraftSummary, OverdraftDrawdownEvaluateResponse, OverdraftOptInResponse, OverdraftOptOutResponse, TCResponse } from './types/response'
import { getApiBaseUrl } from 'config'

// Overdraft route doubled in here for staging because of a gateway issue
const isUat = getApiBaseUrl().includes('onlinetraining.bk.rw')
const overdraftPath = isUat ? '/instant-overdraft/instant-overdraft' : '/instant-overdraft'

const loanEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>, QueryTags, 'data'>) =>
  ({
    getOverdraftTC: builder.query<TCResponse, void>({
      query: () => {
        return `${overdraftPath}/tc/active`
      },
    }),
    overdraftOptIn: builder.mutation<OverdraftOptInResponse, OverdraftOptInRequest>({
      query: (body) => {
        return ({
          url: `${overdraftPath}/enrollment/opt-in`,
          method: 'POST',
          body,
        })
      },
      invalidatesTags: ['customerOverdraftSummary'],
    }),
    overdraftOptOut: builder.mutation<OverdraftOptOutResponse, OverdraftOptOutRequest>({
      query: (body) => {
        return ({
          url: `${overdraftPath}/enrollment/opt-out`,
          method: 'POST',
          body,
        })
      },
      invalidatesTags: ['customerOverdraftSummary'],
    }),
    overdraftLimitChange: builder.mutation<CustomerOverdraftSummary, OverdraftLimitChangeRequest>({
      query: ({accountNumber, ...body}) => {
        return ({
          url: `${overdraftPath}/enrollment/${accountNumber}/limit`,
          method: 'PATCH',
          body,
        })
      },
      invalidatesTags: ['customerOverdraftSummary'],
    }),
    getCustomerOverdraftSummary: builder.query<CustomerOverdraftSummary, { accountNumber: string, }>({
      query: ({ accountNumber }) => {
        return `${overdraftPath}/customers/${accountNumber}`
      },
      providesTags: ['customerOverdraftSummary'],
    }),
    getCustomerDrawdowns: builder.query<CustomerDrawdowns, { customerId: string, page?: number, size?: number, }>({
      query: ({ customerId, ...params }) => {
        return ({
          url: `${overdraftPath}/customers/${customerId}/drawdowns`,
          method: 'GET',
          params,
        })
      },
      // providesTags: ['loanAccounts'],
    }),
    overdraftDrawdownEvaluate: builder.mutation<OverdraftDrawdownEvaluateResponse, OverdraftDrawdownEvaluateRequest>({
      query: (body) => {
        return ({
          url: `${overdraftPath}/drawdown/evaluate`,
          method: 'POST',
          body,
        })
      },
    }),
  })

export default loanEndpoints
